import { render } from "./AboutHistory.vue?vue&type=template&id=c2cebea8"
import script from "./AboutHistory.vue?vue&type=script&lang=js"
export * from "./AboutHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__